// Macro-widgets (Set 12.5) — the node model of the plugin UI surface. A plugin's client.lua composes a
// few FAT, engine-provided widgets (a modal, layout stacks, an icon-grid); sprite-vm.js wraps these as
// the Lua `ui.*` API, and widget-dom.js renders the composed tree as a DOM overlay. See the "macro-
// widgets" artifact.
//
// This is just the tree (compose + walk). Layout + hit-testing are the DOM's job now (CSS grid/flex +
// native events in widget-dom.js), so there's no geometry here — that separation is exactly what let the
// render+input adapter swap from canvas to DOM without touching the Lua API or the plugin.

let nextId = 1;
// A widget node: a type (modal / vstack / hstack / grid), its props, children, a parent, plus per-type
// runtime state. A "grid" (Set 12.5 step 2) is generic: `cells` is a JS data provider (sprite-vm wraps
// the Lua callback), `cellTemplate(item, i)` returns a filled cell's content descriptors (ui.icon /
// ui.label), and onClick/onMove are cell-indexed events. icon_grid is composed from this in a kit plugin.
export function makeWidget(type, props = {}) {
    return {
        id: nextId++, type, props, children: [], parent: null,
        open: false,                   // modal: shown?
        drag: null,                    // grid: an in-flight drag (Option B)
        onClick: null, onMove: null,   // grid cell events (JS fns; sprite-vm bridges to Lua)
        cells: props.cells || null,    // grid data provider () => (array of {item,count}|null)
        cellTemplate: null,            // grid (item, i) => [content descriptor, …] for a filled cell
    };
}

export function addChild(parent, child) {
    if (!parent || !child) return parent;
    child.parent = parent;
    parent.children.push(child);
    return parent;
}

// Every grid in a tree (depth-first) — for walking the composed widgets.
export function gridsOf(root) {
    const out = [];
    (function walk(w) { if (w.type === "grid") out.push(w); for (const c of w.children) walk(c); })(root);
    return out;
}
